import { Component } from '@angular/core';
import { Image } from 'src/graphics/image';
import { WatchAwareComponent } from 'src/app/watch-aware.component';
import { takeUntil } from 'rxjs';
import { Store } from 'src/sync/store';
import { Room } from 'src/sync/room';

@Component({
    selector: 'app-control-uploads',
    templateUrl: './control-uploads.component.html',
    styleUrls: ['./control-uploads.component.scss'],
    standalone: false
})
export class ControlUploadsComponent extends WatchAwareComponent {
    public map: Image | undefined;

    public ngAfterViewInit() {
        Store.activeSprite.pipe(takeUntil(this.destroyed)).subscribe((e) => {
            if (e == null || e.type == 'image') {
                this.map = (e as Image);
                this.changeDetectorRef.detectChanges();
            }
        });
    }

    public update(map: Image) {
        map.emitChanges();
    }

    public delete(map: Image) {
        Room.imageAssets.delete(map.data.id);
        Room.images.delete(map.data.id);
        this.map = undefined;
        this.changeDetectorRef.detectChanges();
    }

    public lock(lock: boolean, map: Image) {
        map.data.locked = lock;
        Room.images.modify(map.data.id, x => x.locked = lock);
        this.changeDetectorRef.detectChanges();
    }
}
